module.exports = __webpack_public_path__ + "static/media/header-logo.02c35f9f.png";